




import { Vue, Component, Prop } from "@/shared/vuepack";

@Component({})
export default class Metric extends Vue {
  @Prop({ required: true }) metricName;
  @Prop({ required: true }) height;
  @Prop({ required: true }) width;
  @Prop({ default: null }) accessToken;
  @Prop({ default: null }) employerCode;
  @Prop({ required: true }) tableauUrl;

  metricHtml = "";

  async mounted () {
    // Disabled until tableau logic is completed
    // await this.renderMetricCard();
  }

  async renderMetricCard () {
    const filter = (this.employerCode) ? `Employer Code=${this.employerCode}` : "";
    this.metricHtml = `
      <object class='tableauViz' width='${this.width}' height='${this.height}' style='display:none;'>
        <param name='host_url' value='${this.tableauUrl}/' />
        <param name='embed_code_version' value='3' />
        <param name='site_root' value='' />
        <param name='name' value='${this.metricName}' />
        <param name='tabs' value='no' />
        <param name='toolbar' value='no' />
        <param name='showAppBanner' value='false' />
        <param name='device' value='desktop' />
        <param name='filter' value='${filter}' />
        <param name='token' value='${await this.accessToken}' />
      </object>
    `;
    window.postMessage("loadtableauview");
  }
}
